import React from 'react';
import BookingForm from './BookingForm';

export default function BookingSection() {
  return (
    <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container">
        <div className="booking p-5">
          <div className="row g-5 align-items-center">
            <div className="col-md-6 text-white">
              <h6 className="text-white text-uppercase">Rentals</h6>
              <h1 className="text-white mb-4">Request Availability</h1>
              <p className="mb-4">
                Planning a day on Cape Coral’s waterways? Tell us when you’d like to go and the boat you prefer. Our team will confirm availability and finalize your reservation.
              </p>
              <p className="mb-4">
                Prefer to talk now? Call <a className="text-white text-decoration-underline" href="tel:+12399801614">(239) 980-1614</a> or email <a className="text-white text-decoration-underline" href="mailto:info@sunbayboats.com">info@sunbayboats.com</a>.
              </p>
              <a className="btn btn-outline-light py-3 px-5 mt-2" href="/contact">
                Contact Us
              </a>
            </div>

            <BookingForm />
          </div>
        </div>
      </div>
    </div>
  );
}
